<ng-container *ngIf="sar$ | async as sar">
    <h2 class="title is-2">Sar asset</h2>
    <div class="sar-asset mb-5 mt-5">
        <isav-sar-display
            noAssetInfo="This infrastructure does not have SAR asset"
            [sar]="sar"
        ></isav-sar-display>
    </div>
</ng-container>
